import React, { useRef, useEffect } from 'react';

const BtnRadius = (props) => {

    const styleRef = useRef(null);

    useEffect( () => {
        if (props.color) {
            styleRef.button.background = props.color;
        }
    });

    return (
        <div className="btn-radius d-flex flex-row space-between" ref={styleRef}>
            <button onClick={props.onClick}>
                {props.text}
            </button>
        </div>
    );
}

export default BtnRadius;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/button/BtnRadius.js